export default class Entity {
  constructor (id, address, email, name, otherInfo, telephone) {
    this.id = id
    this.address = address
    this.email = email
    this.name = name
    this.otherInfo = otherInfo
    this.telephone = telephone
  }
}